
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-editor");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/editor/index.js
// module id = 8lMm
// module chunks = 11